import React from 'react';
import ConfigModal from '../ConfigModal';
import PropTypes from 'prop-types';
import RenewalPeriodSelect from '../RenewalPeriodSelect';
import { RENEWAL_PERIOD } from '../../config/common';

const SocratesChangeRenewalPeriodModal = ({ open, team, onCancel, onSubmit }) => {
	return (
		<ConfigModal
			title={`Ändra förnyelseperiod`}
			open={open}
			onSubmit={onSubmit}
			onCancel={onCancel}
			values={{
				renewalPeriod:
					team && team.renewalPeriod !== undefined
						? RENEWAL_PERIOD[team.renewalPeriod].id
						: undefined,
			}}
			createNew={false}
			disableMask
			formItems={[
				{
					id: 'renewalPeriod',
					label: 'Förnyelseperiod',
					decorator: {
						rules: [{ required: true, message: 'Förnyelseperiod är obligatorisk' }],
					},
					component: <RenewalPeriodSelect />,
				},
			]}
		/>
	);
};

SocratesChangeRenewalPeriodModal.propTypes = {
	team: PropTypes.object.isRequired,
	open: PropTypes.bool,
	onSubmit: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
};

SocratesChangeRenewalPeriodModal.defaultProps = {
	open: false,
};

export default SocratesChangeRenewalPeriodModal;



// WEBPACK FOOTER //
// ./src/components/socrates/socratesChangeRenewalPeriodModal.jsx